import { createAction, createReducer } from '@reduxjs/toolkit';

import { CLEAR_STATE } from '../constants/actionTypes';

/* eslint-disable import/no-cycle */
import { initialState } from './builder';

const clearState = createReducer({}, builder => {
  builder.addCase(createAction(CLEAR_STATE), (stateObj, action) => {
    const { payload } = action;
    const state = stateObj;

    payload.forEach(i => {
      if (state.ui[i]) {
        if (initialState.ui[i] === 0 || initialState.ui[i]) {
          state.ui[i] = initialState.ui[i];
        } else {
          state.ui[i] = null;
        }
      }
      if (state.server[i] || state.server[i] === 0) {
        state.server[i] = null;
      }
    });
    return state;
  });
});

export default clearState;
